exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".observation-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  position: relative;\n  z-index: 1001;\n  width: 100%;\n}\n.observation-header .toggle-fullscreen {\n  position: absolute;\n  left: 30px;\n  top: 10px;\n}\n.observation-header button.btn:active,\n.observation-header button.btn:focus {\n  outline: none;\n}\n.observation-header .observation-timer-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  width: 40%;\n  text-align: center;\n  font-size: 18px;\n  margin-right: 10px;\n}\n.observation-header .observation-controls {\n  position: absolute;\n  right: 30px;\n  top: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.observation-header .observation-controls .undo-button {\n  margin-right: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/ObservationHeader.styl
// module id = 1905
// module chunks = 1